export type SortingShape = {
  order: SortingOrder;
  fieldKey: SortingFieldKey;
};

export enum SortingOrder {
  asc = 'asc',
  desc = 'desc',
}

export enum SortingFieldKey {
  name = 'name',
  extension = 'extension',
  created_at = 'created_at',
}

export function isSortingOrder(str: string): str is SortingOrder {
  return Object.values(SortingOrder).includes(str as SortingOrder);
}

export function isSortingFieldKey(str: string): str is SortingFieldKey {
  return Object.values(SortingFieldKey).includes(str as SortingFieldKey);
}
